window.theme = window.theme || {};

theme.dependTypeLibs = {
  "navigation-vertical": "navigation-section",
  "product": "product-global",
  "collection-template": "nouislider"
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _beforeCreateInstance: function(container, constructor, type) {
    if(!type) {
      type = $(container).attr('data-section-type');
    }
    if(theme.dependTypeLibs[type] == undefined) {
      BT.loadCssJsLib(type + '-section', function() {
        if(this.constructors[type] == undefined) {
          this.constructors[type] = constructor;
        }
        this._createInstance(container, constructor);
      }.bind(this));
    } else {
      BT.loadCssJsLib(theme.dependTypeLibs[type], function() {
        BT.loadCssJsLib(type + '-section', function() {
          if(this.constructors[type] == undefined) {
            this.constructors[type] = constructor;
          }
          this._createInstance(container, constructor);
        }.bind(this));
      }.bind(this));
    }
  },

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._beforeCreateInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._beforeCreateInstance(container, constructor, type);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

theme.sections = new theme.Sections();
BT.loadRequireCss();
BT.init();
function registerSections() {
  theme.sections.register('navigation', theme.DesktopNavigationSection);
  theme.sections.register('navigation-vertical', theme.VerticalNavigationSection);
  theme.sections.register('navigation-mobile', theme.MobileNavigationSection);
  theme.sections.register('instagram', theme.InstagramSection);
  theme.sections.register('rich-banner-text', theme.RichBannerTextSection);
  theme.sections.register('layer-banner', theme.LayerBannerSection);
  theme.sections.register('simple-product-slider', theme.SimpleProductSliderSection);
  theme.sections.register('product', theme.ProductTemplateSection);
  theme.sections.register('product-tabs', theme.ProductTabsSection);
  theme.sections.register('product-columns', theme.ProductColumnsSection);
  theme.sections.register('map', theme.Maps);
  theme.sections.register('quotes', theme.QuotesSection);
  theme.sections.register('featured-blog', theme.FeaturedBlogSection);
  theme.sections.register('logo-bar', theme.LogoListSection);
  theme.sections.register('single-deal', theme.SingleDealSection);
  theme.sections.register('about', theme.AboutSection);
  theme.sections.register('newsletter', theme.NewsletterSection);
  theme.sections.register('collection-filter', theme.CollectionFilterSection);
  theme.sections.register('footer', theme.FooterSection);
  theme.sections.register('collection-template', theme.CollectionTemplateSection);
  theme.sections.register('search-template', theme.SearchTemplateSection);
  theme.sections.register('cart-template', theme.CartTemplateSection);
  theme.sections.register('faq', theme.faqSection);
}
if(BT.data.cacheWindowWidth <= BT.options.windowScreen.mobile) {
  $(document).ready(function() {
    registerSections();
  });
} else {
  registerSections();
}
if (window.self === window.top && 'serviceWorker' in navigator && theme.pwaEnable && window.location.href.indexOf('/checkout/') < 0) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/a/bt-toolkit/js/sw.js',{ scope: "/" })
      .then(function (registration) {
        registration.update();
      })
      .catch((err) => console.log("Error", err));
  });
}


/////// CUSTOM CODE

$(window).on('load', function() {

//   $('#shopify-section-16168813155fd86c77  .slick-list .slick-slide').click(function() {
//     if ( $(this).find('.banner-item__link-list').css('visibility') == 'hidden' ) {
//       $(this).find('.banner-item__link-list').css('visibility','visible');
//     } else {
//       $(this).find('.banner-item__link-list').css('visibility','hidden');
//     }
//   });
  
  head = $("iframe#loyaltylion-beacon-frame").contents().find("head");
  let css = '<style>.UEPNX svg{display:none;} .UEPNX{background:none;}</style>';
  $(head).append(css);
  
//   $(".tmg-details-table.general-info-tbl tr td:nth-of-type(2)").each(function( index ) {
//     var currentTD = $(this);
//     var productDescriptionWords = $(this).text().split("/").split(" ");
//     currentTD.empty();
//     $.each(productDescriptionWords, function(i, v) {
//         currentTD.append($("<span>").text(v)).append(" ");
//     });
//     productDescriptionWords = "";
//   });
  
  $('select.select__search-page option:contains("Article")').text('Blog');
  
  $(".footer__linklist-item a[title='My Wishlist']").click(function(e) {
    e.preventDefault();
  });
  
  $('.footer__linklist-item a[title="My Wishlist"]').addClass('header__link--wishlist');
  
  $('.snize-product-label.down-left').html('<a target="_blank" href="https://wa.me/96171909444">Request Price</a>');
  
  $('#snize_results .snize-search-results-main-content').before($('#collection-linklist'));

  $('.banner-item--9b8443aa-58a1-4b74-aacf-ff40c05381c8').click(function(){
    window.location = '/collections/all-items';
  });
  $('.banner-item--741a310b-6ce3-4f24-bb94-996eaa084f86').click(function(){
    window.location = '/collections/all-items';
  });
  $('.banner-item--20e3fadf-a72b-4b51-831b-6d07576d02d6').click(function(){
    window.location = '/collections/all-items';
  });
  $('.banner-item--feefce53-92f8-4043-b69f-5c07ce89c932').click(function(){
    window.location = '/collections/all-items';
  });
  
  $('iframe#loyaltylion-beacon-frame').ready(function() {
    //$('a.header__link--compare').css('display', 'flex');
    $('iframe#loyaltylion-beacon-frame').css('visibility', 'visible');
  });
    
  if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    $('#mobile-btn-fb').attr('href','fb://page/431067906927857');
  }

  $('.mmm-bakers .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/bakers-corner">View All</a>');
  $('.mmm-dairy .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/dairy-beyond">View All</a>');
  $('.mmm-charcuterie .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/the-charcuterie">View All</a>');
  $('.mmm-sea .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/from-the-sea">View All</a>');
  $('.mmm-pantry .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/the-pantry">View All</a>');
  $('.mmm-ready .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/ready-when-you-are">View All</a>');
  $('.mmm-sweet .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/sweet-moments">View All</a>');
  $('.mmm-cuvee .h2m-mega-wrapper > .h2m-back-btn').append('<a href="/collections/cuvee-co">View All</a>');
});